import { INavConfig } from '@pendwa/common-browser/components/Navs/Nav/types.js';
import { IContextPageDataViewer } from '@pendwa/common-browser/context/PageData/index.js';
import { linksDesktop } from './desktop/index.js';
import { linksMobileTablet } from './mobileTablet/index.js';

export const getNavConfig = (params: { viewer?: IContextPageDataViewer }): INavConfig => {
  return {
    desktop: linksDesktop(params),
    mobile_tablet: linksMobileTablet(params),
  };
};
